import * as React from 'react';
import { ITranslationsCollection, translate } from 'elc-service';
import { UNDERTONE } from '../../constants/UndertoneOptions';
import { observer } from 'mobx-react';
import { IMapping } from '../../../exported/product-cta/ProductCTA';

export interface IColorFamilyLabels {
    name: string;
    translations?: ITranslationsCollection;
}

export const UndertoneLabel = translate([
    'coolUndertoneLabel',
    'neutralUndertoneLabel',
    'warmUndertoneLabel',
    'goldenUndertoneLabel'
])(
    observer((props: IColorFamilyLabels) => {
        const { name } = props;

        const {
            coolUndertoneLabel,
            neutralUndertoneLabel,
            warmUndertoneLabel,
            goldenUndertoneLabel
        } = props.translations as ITranslationsCollection;

        const undertoneLabels: IMapping = {
            [UNDERTONE.COOL]: coolUndertoneLabel,
            [UNDERTONE.NEUTRAL]: neutralUndertoneLabel,
            [UNDERTONE.WARM]: warmUndertoneLabel,
            [UNDERTONE.GOLDEN]: goldenUndertoneLabel
        };

        return <span>{undertoneLabels[name] || name} </span>;
    })
);
